import { useRef } from "react";
import { IAllRequirements } from "../../models/AllRequirements";
import { IPermissionProps } from "../../models/Login";
import { Table } from "./Table";
import { Toast } from "primereact/toast";

interface Iprops {
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export interface IModel2 {
    open: boolean,
    singleData: IAllRequirements
}

export const Float = (permissions: IPermissionProps) => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} permissions={permissions}/>
            <Toast ref={toast} />
        </>
    );
}
